import qs from "qs";
import requestToApi, { ApiCallParams } from "../baseService";
import { CmsBodyClassVm, CmsPageVm, CmsCriteria, CmsMenuVm } from "./domain";

export async function getBodyClassNameApi(subdomain: string) {
  const response = await requestToApi(
    `/api/cms/bodyclassname?subdomain=${subdomain}`,
    "get",
    false
  );
  if (response) {
    const result: CmsBodyClassVm = response;
    return result;
  }

  return undefined;
}

export async function getPageApi(params: ApiCallParams<CmsCriteria>) {
  const query = params ? qs.stringify(params) : "";

  const response = await requestToApi(`/api/cms/page?${query}`, "get", false);
  if (response) {
    const result: CmsPageVm = response;
    return result;
  }

  return undefined;
}

export async function getMenuApi(subdomain: string) {
  const response = await requestToApi(
    `/api/cms/menu?subdomain=${subdomain}`,
    "get",
    false
  );
  if (response) {
    const result: CmsMenuVm = response;
    return result;
  }

  return undefined;
}
